import { Box, Image, Skeleton, Text } from '@chakra-ui/react';
import { Paper, TextShowMore } from 'components';
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { getImageUrl } from 'utils';
import { DiscountInfo } from '../types';
import { PrimaryButton } from './Buttons';

const ButtonStyled = styled(PrimaryButton)`
  position: sticky;
  margin-top: 8px;
  bottom: 8px;
  right: 0;
  border: 1px solid ${({ theme }) => theme.colors.highlight};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

interface DiscountProps {
  discount: DiscountInfo;
  widgetId: string;
}

const Discount: React.FC<DiscountProps> = ({ discount, widgetId }) => {
  const { id, description, hasPicture, overrideName } = discount;
  return (
    <Paper mb={4}>
      {hasPicture && widgetId && (
        <Image
          w="100%"
          height="306px"
          objectFit="cover"
          borderRadius="lg"
          src={getImageUrl(widgetId, 'Discount', id)}
          alt=""
          fallback={<Skeleton height="306px" />}
        />
      )}
      <Box w="100%">
        <Text color="black" textStyle="h4" my="4">
          {overrideName}
        </Text>
        {description && <TextShowMore text={description} />}
      </Box>
    </Paper>
  );
};

interface DetailsDiscountProps {
  discount: DiscountInfo;
  widgetId: string;
  discounts: DiscountInfo[];
}

export const DetailsDiscount: React.FC<DetailsDiscountProps> = ({
  discount,
  discounts,
  widgetId,
}) => {
  const [isShowAll, setShowAll] = useState<boolean>(false);
  const handleShowAllDiscounts = () => setShowAll(true);

  return isShowAll ? (
    <div>
      {discounts.map((item) => (
        <Discount discount={item} widgetId={widgetId} key={item.id} />
      ))}
    </div>
  ) : (
    <>
      <Discount discount={discount} widgetId={widgetId} />
      {discounts.length > 1 && (
        <ButtonStyled
          w="343px"
          alignSelf="center"
          onClick={handleShowAllDiscounts}
        >
          Посмотреть все акции
        </ButtonStyled>
      )}
    </>
  );
};
